// In this file we will create all states we want to share in the app
import { useState,createContext } from "react";
import { useProductsContext } from "../hooks/useProductsContext";


export const CartContext = createContext();

export const CartProvider = props =>{

    const {products} = useProductsContext()

    const getDefaultCart = () => {
        let cart = {};
        for (let i = 1; i < products.length + 1; i++) {
          cart[i] = 0;
        }
        return cart;
      };

    const [cartItems,setCartItems] = useState()

    // function addToCart(itemId){
    //     setCartItems(prevItem=> ({...prevItem, [itemId]: prevItem[itemId] + 1 }))
    // }

    function addToCart(itemId) {
        setCartItems((prevItems) => {
          const updatedItems = { ...prevItems };
      
          if (updatedItems[itemId]) {
            updatedItems[itemId] += 1;
          } else {
            updatedItems[itemId] = 1;
          }
      
          return updatedItems;
        });
      }

    function removeFromCart(itemId){
        setCartItems(prevItem=> ({...prevItem, [itemId]: prevItem[itemId] - 1 }))
    }

    function calculateTotalAmount(){
        let totalAmount = 0
        for(const item in cartItems){
            if(cartItems[item] > 0){
            let itemInfo = products.find((product)=> product._id === item )
        console.log(itemInfo)
           totalAmount += cartItems[item] * itemInfo.price
        }
           
        }
        return totalAmount
    }

    function emptyCart(){
        setCartItems(getDefaultCart())
    }
     
    // console.log(cartItems)
    return(
        <CartContext.Provider value={{cartItems,addToCart,removeFromCart,emptyCart,calculateTotalAmount}}>
            {props.children}
        </CartContext.Provider>
    )

}
